import { ExchangeOrders } from "@/components/ExchangeOrders";

/** Every order placed on the user's exchange accounts. */
export default function OrdersPage() {
  return (
    <div className="flex min-w-0 flex-col gap-5">
      <div>
        <h1 className="m-0 text-[22px] font-semibold tracking-[-0.01em] text-[var(--text-primary)]">Trades</h1>
        <p className="m-0 mt-1 text-[13px] text-[var(--text-muted)]">
          The orders that filled on your exchanges, with the P&amp;L of each one that closed a position. Open an order for its details.
        </p>
      </div>
      <ExchangeOrders />
    </div>
  );
}
